var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from "class-transformer";
import { observable } from "mobx";
import { DocumentRetrievalStep } from "./DocumentRetrievalViewModel";
export class DocumentRetrievalUIState {
    constructor() {
        this.loadingStart = undefined;
        this.now = undefined;
        this.patientId = null;
        this.studyId = null;
        this.isStatic = false;
        this.hasCompletedStaticLoginCycle = false;
        this.showDocumentSelectionScreen = true;
        this.showFastenImmediately = false;
        this.hasSeenDocumentSelectionScreen = false;
        this.hasSeenRecordsNotFoundScreen = false;
        this.hasDeclinedSharing = false;
        this.currentLocationKeyForLogin = null;
        this.loginRequiredLocationKeys = [];
        this.currentLoginIndex = 0;
        this.completedLoginKeys = [];
        this.skippedLoginKeys = [];
        this.includedLoginKeys = [];
        this.excludedLoginKeys = [];
        this.isInLoginCycle = false;
        this.pendingSkipLocationKey = null;
    }
}
__decorate([
    Type(() => Date),
    observable,
    __metadata("design:type", Object)
], DocumentRetrievalUIState.prototype, "loadingStart", void 0);
__decorate([
    Type(() => Date),
    observable,
    __metadata("design:type", Object)
], DocumentRetrievalUIState.prototype, "now", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DocumentRetrievalUIState.prototype, "patientId", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DocumentRetrievalUIState.prototype, "studyId", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], DocumentRetrievalUIState.prototype, "isStatic", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], DocumentRetrievalUIState.prototype, "hasCompletedStaticLoginCycle", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], DocumentRetrievalUIState.prototype, "staticRetrievalData", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], DocumentRetrievalUIState.prototype, "showDocumentSelectionScreen", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], DocumentRetrievalUIState.prototype, "showFastenImmediately", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], DocumentRetrievalUIState.prototype, "hasSeenDocumentSelectionScreen", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], DocumentRetrievalUIState.prototype, "hasSeenRecordsNotFoundScreen", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], DocumentRetrievalUIState.prototype, "hasDeclinedSharing", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DocumentRetrievalUIState.prototype, "currentLocationKeyForLogin", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], DocumentRetrievalUIState.prototype, "loginRequiredLocationKeys", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], DocumentRetrievalUIState.prototype, "currentLoginIndex", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], DocumentRetrievalUIState.prototype, "completedLoginKeys", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], DocumentRetrievalUIState.prototype, "skippedLoginKeys", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], DocumentRetrievalUIState.prototype, "includedLoginKeys", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], DocumentRetrievalUIState.prototype, "excludedLoginKeys", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], DocumentRetrievalUIState.prototype, "isInLoginCycle", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DocumentRetrievalUIState.prototype, "pendingSkipLocationKey", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], DocumentRetrievalUIState.prototype, "stepToShow", void 0);
